module.exports = __webpack_public_path__ + "static/media/Done_Button@3x.65d04dcb.png";